export enum ChartType {
	BY_PICKUP_OPTION = "BY_PICKUP_OPTION",
	SALES_BY_STORE = "SALES_BY_STORE",
	ORDERS_BY_DATE = "ORDERS_BY_DATE",
	BY_PAYMENT_TYPE = "BY_PAYMENT_TYPE",
	AVERAGE_TICKET = "AVERAGE_TICKET",
	SALES_BY_PRODUCT = "SALES_BY_PRODUCT",
	DELIVERY_FEE = "DELIVERY_FEE",
	TOP_DAYS_SALES = "TOP_DAYS_SALES",

	RESERVATION_TOTAL = "RESERVATION_TOTAL",
	RESERVATION_QUOTES = "RESERVATION_QUOTES",
	RESERVATION_CREATED_BY = "RESERVATION_CREATED_BY",
	RESERVATION_BY_DATE = "RESERVATION_BY_DATE",
	RESERVATION_TOP_DAYS = "RESERVATION_TOP_DAYS",
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/chart-type.enum.ts